<template>
<div class="chapter">
<div class="inner_page">
<p class="crt"><a id="page_ii"><i>Prisoners without Bars: A Caregiver’s Tale</i></a></p><a id="page_ii">
<p class="crt1">© 2018 Donna O’Donnell Figurski. All rights reserved.</p>
<p class="crt2">No part of this book may be reproduced or transmitted in any form or by any means, electronic or mechanical, including photocopying, recording, or by any information storage and retrieval system, without permission in writing from the publisher.</p>
<p class="crt2">This story is told from the author’s experience and perspective. Some names and identifying details have been changed to protect the privacy of individuals.</p>
<p class="crt2">Published in the United States by WriteLife Publishing</p>
<p class="crt1">(An imprint of Boutique of Quality Books Publishing Company)</p>
</a><p class="crt1"><a id="page_ii"></a><a href="http://www.writelife.com" id="ATj" target="_blank">www.writelife.com</a></p>
<p class="crt2">978-1-60808-205-6 (p)</p>
<p class="crt1">978-1-60808-206-3 (e)</p>
<p class="crt2">Library of Congress Control Number: 2018956542</p>
<p class="crt2">Book design by Robin Krauss, <a href="http://www.bookformatters.com" id="A0E5" target="_blank">www.bookformatters.com</a></p>
<p class="crt1">Cover design by Marla Thompson, <a href="http://www.edgeofwater.com" id="A3qk" target="_blank">www.edgeofwater.com</a></p>
<p class="crt2">First editor: Olivia Swenson</p>
<p class="crt3">Second editor: Caleb Guard</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyrightpage.vue?91713450